<template>
  <div v-loading="loading">
    <el-form ref="paramForm" prop="paramForm" :model="paramForm" :rules="rules" label-width="140px" class="addParamForm">
      <el-form-item label="参数名称" prop="name">
        <el-input v-model.trim="paramForm.name" class="h-40 w-300" placeholder="请输入参数名"></el-input>
      </el-form-item>
      <el-form-item label="备注说明" prop="remark">
        <el-input type="textarea" :autosize="{minRows: 2, maxRows: 4}" class="w-300" placeholder="请输入备注说明" v-model.trim="paramForm.remark">
        </el-input>
      </el-form-item>
      <el-form-item label="请选择数据表" prop="table_name">
        <el-select class="w-300" v-model="tableItem" filterable placeholder="输入内容搜索">
          <el-option v-for="tableItem in tableList" :label="tableItem.name" :value="tableItem">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="请选择字段名" prop="field_name">
        <el-select class="w-300" v-model="paramForm.field_name" filterable placeholder="输入内容搜索">
          <el-option v-for="filedItem in fieldList" :key="filedItem" :label="filedItem" :value="filedItem">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主键ID" prop="foreign_key">
        <el-input v-model.trim="paramForm.foreign_key" class="h-40 w-300" placeholder="输入键名"></el-input>
      </el-form-item>
      <el-form-item label="是否为序列化字段" prop="is_serialize">
        <el-radio-group v-model="paramForm.is_serialize" @change="selectSerialize">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="要配置的键" prop="config_key" v-if="paramForm.is_serialize === 1">
        <el-input v-model.trim="paramForm.config_key" class="h-40 w-300" placeholder="输入键名"></el-input>
        <div class="sub-title" style="color:#1f2d3d;">以斜杠区分数组层级，如三维写法config/select/value</div>
      </el-form-item>
      <div v-if="paramForm.is_serialize === 1" >
        <el-form-item label="参数是否为多组" prop="groups">
          <el-radio-group v-model="paramForm.groups" @change="selectGroups">
            <el-radio :label="20">多组,可以自由添加或者删除多组数据</el-radio>
            <div style="margin: 15px 0;"></div>
            <el-radio :label="10">单组,如分页，是一个参数值，不能添加多组数据</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div v-if="paramForm.is_serialize === 1">
        <!--修改为表格-->
        <el-table
          :data="paramForm.dimension"
          style="width: 850px">
          <el-table-column
            label="序号"
            type="index"
            width="70">
          </el-table-column>
          <el-table-column
            label="是否隐藏"
            width="120">
            <template scope="scope">
              <div>
                <el-checkbox :true-label="selectTrue"  :false-label="selectFalse" v-model="scope.row.is_hidden">隐藏</el-checkbox>              
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="列名">
            <template scope="scope">
              <div>
                <el-input v-model="scope.row.colume_name" placeholder="请输入列名" class="w-150"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="键名">
            <template scope="scope">
              <div>
                <el-input v-model="scope.row.key" placeholder="请输入键名" class="w-150"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="类型">
            <template scope="scope">
              <div>
                <el-select v-model="scope.row.type">
                  <el-option
                   v-for="item in selectTypeList"
                   :key="item"
                   :label="item.title"
                   :value="item.type"
                   ></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="70">
            <template scope="scope">
              <div>
                <el-button size="small" type="danger" @click="deleteDimensionItem(scope.$index)" :disabled="paramForm.dimension.length === 0">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!--<el-form-item v-for="(dimensionItem,dimensionIndex) in paramForm.dimension" :label="dimensionIndex === 0 ? '维度名' : ''" :class="{'is-error': checkDimensionList[dimensionIndex].isError }" style="content: '*';color: #ff4949;margin-right: 4px;">
          <el-input class="h-40 w-300" v-model.trim="paramForm.dimension[dimensionIndex]" placeholder="请输入维度" @blur="checkDimensionValue(dimensionIndex)" @change="checkDimensionValue(dimensionIndex)"></el-input>
          <el-button type="danger" @click="deleteDimensionItem(dimensionIndex)" :plain="paramForm.dimension.length===1 " :disabled="paramForm.dimension.length===1" title="至少输入一条维度名">删除</el-button>
          <transition name="dimension">
            <div class="el-form-item__error" v-if="checkDimensionList[dimensionIndex].isError">请至少输入一条维度名</div>
          </transition>
        </el-form-item>-->
      </div>
      <el-button type="primary" @click="addDimensionItem()" style="margin-bottom:40px;width:850px" v-if="paramForm.is_serialize === 1 && paramForm.groups === 20">添加维度名</el-button>
      <el-form-item class="paramFormButton">
        <el-button type="primary" :loading="isLoading" @click="submitParamData">提交</el-button>
        <el-button @click="goback">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import http from '../../assets/js/http'
export default {
  props: {
    dataID: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      paramForm: {
        name: '',
        remark: '',
        table_name: '',
        field_name: '',
        foreign_key: '',
        is_serialize: 0,
        config_key: '',
        groups: '',
        dimension: []
      },
      rules: {
        name: [
          { required: true, message: '请输入参数名' }
        ],
        remark: [
          { required: true, message: '请输入备注说明' }
        ],
        table_name: [
          { required: true, message: '请选择数据表' }
        ],
        field_name: [
          { required: true, message: '请选择字段名' }
        ],
        foreign_key: [
          { required: true, message: '请输入主键ID' }
        ],
        is_serialize: [
          { required: true, message: '请选择参数' }
        ],
        config_key: [
          { required: true, message: '请输入要配置的键' }
        ],
        groups: [
          { required: true, message: '请选择参数' }
        ]
      },
      tableList: [],
      fieldList: [],
      tableItem: null,
      isLoading: false,
      loading: false, // 全局加载
      checkDimensionList: [], // 维度名校验列表
      selectTypeList: [
        { type: 10, title: 'checkbox' },
        { type: 20, title: 'radio' },
        { type: 30, title: '文本(整数)' },
        { type: 40, title: '文本框' }
      ],
      selectTrue: 1,
      selectFalse: 0
    }
  },
  methods: {
    checkDimensionValue(dimensionIndex) {
      if (!this.paramForm.dimension[dimensionIndex]) {
        this.checkDimensionList[dimensionIndex].isError = true
        return
      }
      this.checkDimensionList[dimensionIndex].isError = false
    },
    getDimensionModel() {
      let model = {
        colume_name: '',
        is_hidden: 0,
        key: '',
        type: 10
      }
      return model
    },
    addDimensionItem() {
      let dimesionModel = this.getDimensionModel()
      this.paramForm.dimension.push(dimesionModel)
      this.checkDimensionList.push({ isError: false })
    },
    deleteDimensionItem(index) {
      this.paramForm.dimension.splice(index, 1)
      this.checkDimensionList.splice(index, 1)
    },
    // 选择是否序列化数据
    selectSerialize() {
      // 取消序列化
      if (this.paramForm.is_serialize === 0) {
        this.paramForm.groups = ''
        this.paramForm.dimension = []
        this.checkDimensionList = []
      } else if (this.paramForm.is_serialize === 1 && this.paramForm.dimension.length < 1) {
        this.paramForm.groups = 10
        let model = this.getDimensionModel()
        this.paramForm.dimension = [model]
        this.checkDimensionList = [{ isError: false }]
      }
    },
    // 选择是否多组
    selectGroups() {
      // 单组
      if (this.paramForm.groups === 10 && this.paramForm.dimension.length > 1) {
        _g.toastMsg(this, 'error', '单组只能存在一条维度名')
        this.paramForm.groups = 20
      }
    },
    validateForm() {
      let validated = true
      this.$refs.paramForm.validate((res) => {
        if (!res) {
          validated = false
        }
      })
      // 维度名 key校验
      if (this.paramForm.is_serialize === 1) {
        _(this.paramForm.dimension).forEach((res, index) => {
          console.log(res)
          if (!res.colume_name || !res.key) {
            this.checkDimensionList[index].isError = true
            validated = false
          }
        })
      }
      if (!validated) {
        _g.toastMsg(this, 'error', '请检查信息是否输入完整')
      }
      return validated
    },
    submitParamData() {
      this.isLoading = true
      // 校验数据-表单校验
      if (!this.validateForm()) {
        this.isLoading = false
        return
      }
      // 提交数据-接口校验
      let postData = _.cloneDeep(this.paramForm)
      if (this.dataID === -1) {
        delete postData.id
        this.apiPost('pd/config', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
            this.isLoading = false
          }
        })
      } else {
        this.apiPut(`pd/config/${this.dataID}`, '', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
            this.isLoading = false
          }
        })
      }
      this.isLoading = false
    },
    goback() {
      router.go(-1)
    },
    getDataTable() {
      // 获取数据表数据
      // form/models
      this.apiGet(`pd/users/getAllTables`).then((res) => {
        if (res.code === 200) {
          this.tableList = res.data
        } else {
          _g.dealError(this, res)
        }
      })
    },
    getDataField(id) {
      // 获取数据表字段数据
      let postData = { type: 0 }
      this.apiGet(`form/models/${id}/fields`,postData).then((res) => {
        if (res.code === 200) {
          this.fieldList = res.data
        } else {
          _g.dealError(this, res)
        }
      })
    },
    init() {
      if (this.dataID !== -1) {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 1000)
        // 获取数据详情
        this.apiGet(`pd/config/${this.dataID}`).then((res) => {
          if (res.code == 200) {
            if (res.data.dimension && res.data.dimension.length === 0) {
              let model = this.getDimensionModel()
              res.data.dimension.push(model)
            }
            _(res.data.dimension).forEach((res) => {
              this.checkDimensionList.push({ isError: false })
            })
            this.paramForm = res.data
            this.tableItem = res.data.table_name
          } else {
            _g.dealError(this, res)
            setTimeout(() => {
              this.goback()
            }, 1000)
          }
        })
      }
      this.getDataTable()
    }
  },
  created() {
    this.init()
  },
  watch: {
    tableItem() {
      if (this.tableItem.name) {
        this.paramForm.table_name = this.tableItem.name
        this.paramForm.field_name = ''
        this.fieldList = this.tableItem.fields
        // this.getDataField(this.tableItem.id)
      }
    }
  },
  mixins: [http]
}
</script>
<style>
.addParamForm {
  margin-left: 50px;
}
.addParamForm .el-form-item__label {
  text-align: left;
}
.addParamForm .el-form-item__label:before {
  content: '*';
  color: #ff4949;
  margin-right: 4px;
}
.paramFormButton .el-form-item__content {
  margin-left: 0px!important;
}
.dimension-enter-active {
  transition: all .5s
}
.dimension-enter {
  transform: translateY(-5px)
}
.dimension-leave-active {
  transition: all .5s;
  transform: translateY(-5px)
}
</style>


// WEBPACK FOOTER //
// paramForm.vue?6a4539d4